/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileViewsFeature } from './';
import {
    ProfileViewsFeatureFromJSON,
    ProfileViewsFeatureFromJSONTyped,
    ProfileViewsFeatureToJSON,
} from './';
import type { SpellingCorrectionFeature } from './';
import {
    SpellingCorrectionFeatureFromJSON,
    SpellingCorrectionFeatureFromJSONTyped,
    SpellingCorrectionFeatureToJSON,
} from './';
import type { StrategyEligibilityFeature } from './';
import {
    StrategyEligibilityFeatureFromJSON,
    StrategyEligibilityFeatureFromJSONTyped,
    StrategyEligibilityFeatureToJSON,
} from './';
import type { TranslationPreferenceFeature } from './';
import {
    TranslationPreferenceFeatureFromJSON,
    TranslationPreferenceFeatureFromJSONTyped,
    TranslationPreferenceFeatureToJSON,
} from './';

/**
 * 
 * @export
 * @interface FeaturesResponse
 */
export interface FeaturesResponse {
    /**
     * 
     * @type {ProfileViewsFeature}
     * @memberof FeaturesResponse
     */
    profileViews?: ProfileViewsFeature;
    /**
     * 
     * @type {StrategyEligibilityFeature}
     * @memberof FeaturesResponse
     */
    strategyEligibility: StrategyEligibilityFeature;
    /**
     * 
     * @type {SpellingCorrectionFeature}
     * @memberof FeaturesResponse
     */
    spellingCorrection?: SpellingCorrectionFeature;
    /**
     * 
     * @type {TranslationPreferenceFeature}
     * @memberof FeaturesResponse
     */
    translationPreference: TranslationPreferenceFeature;
}

/**
 * Check if a given object implements the FeaturesResponse interface.
 */
export function instanceOfFeaturesResponse(value: object): value is FeaturesResponse {
    if (!('strategyEligibility' in value) || value['strategyEligibility'] === undefined) return false;
    if (!('translationPreference' in value) || value['translationPreference'] === undefined) return false;
    return true;
}

export function FeaturesResponseFromJSON(json: any): FeaturesResponse {
    return FeaturesResponseFromJSONTyped(json, false);
}

export function FeaturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeaturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'profileViews': json['profileViews'] == null ? undefined : ProfileViewsFeatureFromJSON(json['profileViews']),
        'strategyEligibility': StrategyEligibilityFeatureFromJSON(json['strategyEligibility']),
        'spellingCorrection': json['spellingCorrection'] == null ? undefined : SpellingCorrectionFeatureFromJSON(json['spellingCorrection']),
        'translationPreference': TranslationPreferenceFeatureFromJSON(json['translationPreference']),
    };
}

export function FeaturesResponseToJSON(value?: FeaturesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileViews': ProfileViewsFeatureToJSON(value['profileViews']),
        'strategyEligibility': StrategyEligibilityFeatureToJSON(value['strategyEligibility']),
        'spellingCorrection': SpellingCorrectionFeatureToJSON(value['spellingCorrection']),
        'translationPreference': TranslationPreferenceFeatureToJSON(value['translationPreference']),
    };
}

